
import { getSmsLog } from '@/api/product/product'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'smsLog',
  components: {}
})
export default class extends Vue {
  private date: any[] = getCurrentDate()
  private form: any = {
    message: null,
    start_time: null,
    end_time: null,
    account_name: null,
    account_no: null,
    user_id: null
  }
  private listLoading: boolean = false
  private pickerOptions = pickerOptions
  private smsLogList: any[] = []
  private total = 0

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange () {
    if (this.date) {
      this.form.start_time = dateToSeconds(this.date[0])
      this.form.end_time = dateToSeconds(this.date[1])
    } else {
      this.form.start_time = null
      this.form.end_time = null
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      let data: any = {
        ...this.form,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getSmsLog(data).then((res: any) => {
        this.total = res.count
        this.smsLogList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select () {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.form = {
      message: null,
      start_time: null,
      end_time: null,
      account_name: null,
      account_no: null,
      user_id: null
    }
    this.date = getCurrentDate()
    this.currentPage = 1
    this.pickerChange()
    this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted () {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.smsLog`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
